import { APP_NAME } from '@/lib/constants';

// Keep the required-check name byte-identical across create calls. GitHub still permits multiple
// checks with the same name/head; updates use the check ID, and session recovery uses external_id.
export const AI_REVIEW_CHECK_RUN_NAME = 'cubic · AI code reviewer' as const;
export const AUTO_FIX_LOOP_CHECK_RUN_NAME = 'cubic · Auto-fix' as const;
export const DEMO_CHECK_RUN_NAME = 'cubic · Demo' as const;

export const CUBIC_CHECK_RUN_NAMES: ReadonlySet<string> = new Set([
  AI_REVIEW_CHECK_RUN_NAME,
  AUTO_FIX_LOOP_CHECK_RUN_NAME,
  DEMO_CHECK_RUN_NAME,
]);

/** Whether a check name is one of cubic's own check runs. */
export function isCubicCheckRunName(name: string): boolean {
  return CUBIC_CHECK_RUN_NAMES.has(name);
}

const CUBIC_APP_SLUGS: ReadonlySet<string> = new Set(Object.values(APP_NAME));

type CheckApp = { slug?: string | null } | null | undefined;

/**
 * Whether a check app is one of cubic's GitHub Apps: production, local or staging, which see each
 * other's checks on a repository that installs more than one.
 */
export function isCubicApp(app: CheckApp): boolean {
  return app?.slug != null && CUBIC_APP_SLUGS.has(app.slug);
}

/**
 * Whether a check run is cubic's own: one of its check names, or reported by
 * any cubic GitHub App (`isCubicApp`). The auto-fix loop never treats these as
 * CI: cubic's review check can conclude `failure`, and fixing it would loop
 * cubic on itself.
 */
export function isCubicCheckRun(run: { name: string; app?: CheckApp }): boolean {
  return isCubicCheckRunName(run.name) || isCubicApp(run.app);
}
